import { Constants } from "@cosine/lib/api-models";
import useConnectionStore from "@cosine/stores/useConnectionStore";

export default function () {
  const {
    signalRClient,
  } = useConnectionStore();

  async function createNewChatWithMessage (message: string) {
    const timelineEntryId = await signalRClient.invokeWithReconnect<string>(Constants.CreateTimelineEntry, message);
    return timelineEntryId;
  }

  return {
    createNewChatWithMessage,
  };
}
